import React from "react";
import styles from "@/app/(index)/index.module.css";
import cx from "clsx";
import Image from 'next/image'
import useGlobalStateStore from "@/app/(index)/use-global-state-store";


const MonthMapping: {[key: number]: string} = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
}

interface IProps {
    iconIndex: string;
    name: string,
    nameEn: string,
    termOfOffice: string,
    line1?: string;
    line2?: string;
    line3?: string;
    line1En?: string;
    line2En?: string;
    line3En?: string;
    isFirst?: boolean;
}

const HisDirectorPersonSM: React.FC<IProps> = ( { iconIndex, name, nameEn, termOfOffice, line1 = "主任", line2, line3, line1En = "Director General", line2En, line3En, isFirst = false  } ) => {

    function toInt(strNumber: string, plus: number = 0){
        return parseInt(strNumber) + plus;
    }

    function getOrdinal(n: number): string {
        const suffixes = ['th', 'st', 'nd', 'rd'];
        const v = n % 100;
        return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    }
    const { fontSize, lang } = useGlobalStateStore();
    return (
        <div className={cx("flex justify-between border-b border-gray-300 border-dotted pb-5", isFirst ? "" : "pt-[20px]")}>
            <div className="flex flex-col">
                <div>
                    {lang == "tw" && (
                        <div className={cx("text-[17px] text-[#69a7a3]")}>
                            第{iconIndex}任{line1}{line2}{line3}
                        </div>
                    )}
                    {lang == "en" && (
                        <div className={cx("text-[#69a7a3] text-[17px]")}>
                            {getOrdinal(toInt(iconIndex))} {line1En} {line2En} {line3En}
                        </div>
                    )}
                </div>

                <div className={cx("flex")}>
                    <div className="relative leading-[35px]">
                        <div className="text-[17px]">
                            {lang == "tw" && <>民國{termOfOffice.split(",")[0]}年{termOfOffice.split(",")[1]}月
                                - {termOfOffice.split(",")[2]}年{termOfOffice.split(",")[3]}月</>}
                            {lang == "en" && `${MonthMapping[toInt(termOfOffice.split(",")[1])]} ${toInt(termOfOffice.split(",")[0], 1911)} - ${MonthMapping[toInt(termOfOffice.split(",")[3])]} ${toInt(termOfOffice.split(",")[2], 1911)}`}
                        </div>
                        {lang == "tw" && <div className="text-[43px] font-bold text-[#8d7f4c]">{name}</div>}
                        {lang == "en" && <div className="text-[20px] font-bold text-[#8d7f4c]">{nameEn}</div>}
                    </div>
                </div>
            </div>

            <div>
                <Image
                    src={`/images/Director-${iconIndex}.jpg`}
                    width={154}
                    height={154}
                    alt={lang === "tw" ? name : nameEn}
                    className={cx("rounded-full object-cover max-w-[120px] max-h-[120px] border border-[#a5bdc0]")}
                />
            </div>
        </div>
    );
}

export default HisDirectorPersonSM;
